/**
 * A field possible states
 */
export enum FieldStateRef {
  error = 'error', // The field's value is invalid.
  not_set = 'not_set', // The field has no value set.
  valid = 'valid', // The field's value is invalid.
  no_rule = 'no_rule', // The field has no associated rule (so we can't say it's valid or not).
  unavailable = 'unavailable' // The field isn't available in the context.
}
